import {createActions} from 'reduxsauce';

export const {Types: CatalogueTypes, Creators: CatalogueActionCreators} = createActions ({
    catalogueStart: [null],
    catalogueSuccess: ['data'],
    catalogueFailure: ['error']
});